(function () {
  function findOneElement(ctx, sel) {
    return ctx.querySelector(sel);
  }

  function makeEventNamespace() {
    const l = [];
    return {
      addDelegatedEventListener(c, s, t, cb) {
        const h = (e) => {
          const target = e.target.closest(s);
          if (target && c.contains(target)) cb(target, e);
        };
        c.addEventListener(t, h);
        l.push(() => c.removeEventListener(t, h));
      },
      destroy() {
        l.forEach((r) => r());
      },
    };
  }

  const CustomerRecoverPasswordStatus = {
    create(o) {
      return {
        recoverPasswordFormPostedSuccessfully:
          !!o.recoverPasswordFormPostedSuccessfully,
        recoverPasswordErrorsFound: !!o.recoverPasswordErrorsFound,
      };
    },
  };

  class CustomerLoginSection {
    constructor(section) {
      this.section = section;
      this.namespace = makeEventNamespace();
      this.init();
    }

    init() {
      this.addEvents();
      this.toggleStatus();
      if (
        location.href.includes(
          "return_url=%2Faccount%3Fview%3Dsubscriptions#/home"
        )
      ) {
        location.href = "/";
      }
    }

    addEvents() {
      this.namespace.addDelegatedEventListener(
        this.section,
        'a[href="#recover"]',
        "click",
        (_, e) => {
          e.preventDefault();
          const l = findOneElement(this.section, "#js-login-form");
          const r = findOneElement(this.section, "#js-recover-password");
          const i = findOneElement(
            this.section,
            '#js-recover-password input[type="email"]'
          );
          if (!l || !r || !i) return;
          l.style.display = "none";
          r.style.display = "block";
          i.focus();
        }
      );

      this.namespace.addDelegatedEventListener(
        this.section,
        "#js-hide-recover-form",
        "click",
        (_, e) => {
          e.preventDefault();
          const l = findOneElement(this.section, "#js-login-form");
          const r = findOneElement(this.section, "#js-recover-password");
          const i = findOneElement(
            this.section,
            '#js-login-form input[type="email"]'
          );
          if (!l || !r || !i) return;
          r.style.display = "none";
          l.style.display = "block";
          i.focus();
        }
      );
    }

    toggleStatus() {
      try {
        const el = findOneElement(
          this.section,
          "#js-customer-recover-password-status"
        );
        const json = JSON.parse(el?.innerText || "{}");
        const {
          recoverPasswordFormPostedSuccessfully,
          recoverPasswordErrorsFound,
        } = CustomerRecoverPasswordStatus.create(json);
        const l = findOneElement(this.section, "#js-login-form");
        const r = findOneElement(this.section, "#js-recover-password");
        const s = findOneElement(this.section, "#js-reset-success-message");
        if (!l || !r || !s) return;
        s.style.display = recoverPasswordFormPostedSuccessfully
          ? "block"
          : "none";
        l.style.display = recoverPasswordErrorsFound ? "none" : "block";
        r.style.display = recoverPasswordErrorsFound ? "block" : "none";
      } catch (e) {
        console.error(e);
      }
    }

    unload() {
      this.namespace.destroy();
    }
  }

  function initSection(selector) {
    document
      .querySelectorAll(selector)
      .forEach((section) => new CustomerLoginSection(section));
  }

  document.addEventListener("DOMContentLoaded", () => {
    initSection(".js-customer-login-main");
  });
})();
